(function () {
  'use strict';

  /* ================================================================
     NewPharma — "Encuentra el formato perfecto para ti"

     Una card a la vez. El formato lo elige el SCROLL, con la seccion
     fijada (sticky), EN LOS DOS TAMANOS.

     HISTORIA, PORQUE ESTA SECCION YA CAMBIO DE PATRON TRES VECES:

       22-oct  nace con sticky de 4 escenas
       23-oct  se le QUITA el sticky: la clienta pide poder seguir
               bajando sin recorrer las cuatro cards
       24-oct  se le DEVUELVE, apuntando al video y a la demo del
               paquete `Newpharma_Home_Propuesta_Implementacion`
       24-oct  se extiende a MOVIL

     Lo ultimo venia de un estado roto que conviene no repetir: el CSS
     dejaba el sticky puesto en los dos tamanos, pero este archivo
     gateaba el pintado con `(min-width: 990px)`. Resultado en un
     telefono: 3,6 pantallas de scroll con la card CONGELADA. La demo
     de referencia tiene el efecto en los dos tamanos.

     NO HAY AVANCE AUTOMATICO, y no es un olvido: la escena la manda la
     posicion del scroll, asi que un reloj que la cambiara por su
     cuenta pelearia con ella y la escena volveria sola al soltar. El
     ajuste "Cambia cada" se retiro del schema.

     EL SCROLL NO SE SECUESTRA. No hay `preventDefault` sobre la rueda;
     el navegador scrollea como siempre y este archivo solo LEE cuanto
     se avanzo. Al terminar la ultima escena el sticky se despega solo.

     LA ESCENA ES DISCRETA Y EL FUNDIDO LO HACE EL CSS, igual que en la
     demo: el indice sale de `floor(avance x N)` y la transicion entre
     cards es una `transition` de opacidad. Lo unico continuo es
     `--np-fmt-drift`, el desplazamiento de los assets, que sigue al
     scroll y es lo que da la sensacion de profundidad.

     SIN ESTE ARCHIVO la seccion sigue sirviendo: las cards salen en el
     HTML con su nombre y su enlace. La clase `np-fmt--js` es la que
     activa el apilado.
     ================================================================ */

  function clamp(v, a, b) { return v < a ? a : (v > b ? b : v); }

  function arrancar(raiz) {
    if (raiz.dataset.npFmtActivo) return;
    raiz.dataset.npFmtActivo = '1';

    var escenas = parseInt(raiz.getAttribute('data-escenas'), 10) || 0;
    if (escenas < 1) return;

    var cards = [].slice.call(raiz.querySelectorAll('.np-fmt__card'));
    var infos = [].slice.call(raiz.querySelectorAll('.np-fmt__info'));
    var capas = [].slice.call(raiz.querySelectorAll('.np-fmt__layerset'));
    var ctas = [].slice.call(raiz.querySelectorAll('.np-fmt__ctas > .np-fmt__cta'));
    var dots = [].slice.call(raiz.querySelectorAll('[data-np-fmt-dot]'));
    var barra = raiz.querySelector('[data-np-fmt-barra]');
    var actual = -1;

    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var reduce = mq.matches;
    if (mq.addEventListener) {
      mq.addEventListener('change', function (e) { reduce = e.matches; acomodar(); });
    }

    raiz.classList.add('np-fmt--js');

    var pendiente = false;
    var ultimoPintado = 0;

    function marcar(lista, i) {
      for (var k = 0; k < lista.length; k++) {
        var on = Number(lista[k].getAttribute('data-escena')) === i;
        lista[k].classList.toggle('is-activo', on);
      }
    }

    function aplicar(i) {
      if (i === actual) return;
      actual = i;
      raiz.setAttribute('data-escena-activa', String(i));
      marcar(cards, i);
      marcar(infos, i);
      marcar(capas, i);
      marcar(ctas, i);
      for (var d = 0; d < dots.length; d++) {
        var on = d === i;
        dots[d].classList.toggle('is-activo', on);
        dots[d].setAttribute('aria-selected', on ? 'true' : 'false');
      }
    }

    /* Avance 0..1 a lo largo de toda la seccion. Arranca cuando el
       borde superior llega a 0 y termina cuando queda una pantalla por
       recorrer, que es el alto del sticky. */
    function avance() {
      var r = raiz.getBoundingClientRect();
      var recorrido = r.height - window.innerHeight;
      if (recorrido <= 0) return 0;
      return clamp(-r.top / recorrido, 0, 1);
    }

    function pintar() {
      pendiente = false;
      ultimoPintado = Date.now();

      var p = avance();
      aplicar(Math.min(escenas - 1, Math.floor(p * escenas + 0.00001)));
      if (barra) barra.style.width = (100 / escenas + p * (100 - 100 / escenas)).toFixed(2) + '%';

      /* EL DESPLAZAMIENTO DE LOS ASSETS ES LO UNICO CONTINUO. Cada
         juego se mueve segun lo lejos que este su escena del punto
         actual, y dentro de cada juego las piezas alternan el sentido:
         eso es lo que se lee como profundidad y no como un bloque. */
      if (reduce) return;
      var escala = p * escenas;
      for (var k = 0; k < capas.length; k++) {
        var d = (escala - k) * 18;
        var piezas = capas[k].children;
        for (var j = 0; j < piezas.length; j++) {
          piezas[j].style.setProperty('--np-fmt-drift', Math.round((j % 2 ? 1 : -1) * d) + 'px');
        }
      }
    }

    /* Mismo guardia que en hongos: si el cuadro pedido no llega, el
       flag se queda trabado y la seccion se congela. Con el sello de
       tiempo se vuelve a pedir en vez de esperar al que no vino. */
    function alScroll() {
      if (!enPantalla) return;
      if (pendiente && (Date.now() - ultimoPintado) < 150) return;
      pendiente = true;
      window.requestAnimationFrame(pintar);
    }

    /* ----------------------------------------------------------------
       IR A UNA ESCENA ES MOVER EL SCROLL.

       Es lo unico coherente con que la escena la decida la posicion: si
       una flecha cambiara la card sin mover la pagina, al mover la
       rueda un pixel volveria de golpe a la que corresponde. Se apunta
       un poco adentro del tramo para no quedar en el filo.
       ---------------------------------------------------------------- */
    function irA(i) {
      i = clamp(i, 0, escenas - 1);
      var r = raiz.getBoundingClientRect();
      var top = r.top + window.pageYOffset;
      var recorrido = r.height - window.innerHeight;
      var paso = recorrido / escenas;
      window.scrollTo({
        top: top + (i + 0.12) * paso,
        behavior: reduce ? 'auto' : 'smooth'
      });
    }

    var prev = raiz.querySelector('[data-np-fmt-prev]');
    var next = raiz.querySelector('[data-np-fmt-next]');
    if (prev) prev.addEventListener('click', function () { irA(actual - 1); });
    if (next) next.addEventListener('click', function () { irA(actual + 1); });

    dots.forEach(function (d) {
      d.addEventListener('click', function () {
        irA(parseInt(d.getAttribute('data-np-fmt-dot'), 10) || 0);
      });
    });

    /* Teclado: flechas cuando el foco esta dentro de la seccion. No se
       capturan a nivel documento para no robarle las flechas al resto
       de la pagina. */
    raiz.addEventListener('keydown', function (ev) {
      var d = ev.key === 'ArrowRight' ? 1 : (ev.key === 'ArrowLeft' ? -1 : 0);
      if (!d) return;
      ev.preventDefault();
      irA(actual + d);
    });

    /* Swipe. Solo cuenta si el gesto es MAS HORIZONTAL QUE VERTICAL:
       si no, cualquier scroll con el dedo cambiaria de escena —y aca
       el scroll vertical es justamente el que manda—. */
    var x0 = 0, y0 = 0, siguiendo = false;
    raiz.addEventListener('touchstart', function (ev) {
      if (ev.touches.length !== 1) return;
      x0 = ev.touches[0].clientX;
      y0 = ev.touches[0].clientY;
      siguiendo = true;
    }, { passive: true });

    raiz.addEventListener('touchend', function (ev) {
      if (!siguiendo) return;
      siguiendo = false;
      var t = ev.changedTouches[0];
      var dx = t.clientX - x0;
      var dy = t.clientY - y0;
      if (Math.abs(dx) < 45 || Math.abs(dx) < Math.abs(dy)) return;
      irA(actual + (dx < 0 ? 1 : -1));
    }, { passive: true });

    function acomodar() {
      actual = -1;
      pintar();
    }

    /* ----------------------------------------------------------------
       NO PINTAR MIENTRAS LA SECCION NO SE VE.

       Aca pesaba mas que en hongos: `pintar()` escribe
       `--np-fmt-drift` en las DOCE piezas en cada cuadro, y lo hacia
       tambien con la seccion fuera de pantalla. Son doce escrituras de
       estilo por cuadro de scroll, en toda la portada, para mover
       assets que nadie esta viendo.

       NO SE PIERDE NINGUN CUADRO: el observador vuelve a pintar al
       entrar, igual que `acomodar()` al cambiar el tamano de la
       ventana. Sin `IntersectionObserver` queda en `true` y se comporta
       como antes.
       ---------------------------------------------------------------- */
    var enPantalla = true;
    if ('IntersectionObserver' in window) {
      enPantalla = false;
      new IntersectionObserver(function (es) {
        enPantalla = es[0].isIntersecting;
        if (enPantalla) {
          pendiente = false;
          alScroll();
        }
      }, { rootMargin: '150px 0px' }).observe(raiz);
    }

    window.addEventListener('scroll', alScroll, { passive: true });
    window.addEventListener('resize', acomodar, { passive: true });

    acomodar();
  }

  function init() {
    var nodos = document.querySelectorAll('[data-np-fmt]');
    for (var i = 0; i < nodos.length; i++) arrancar(nodos[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  // El editor redibuja la seccion al cambiar un ajuste
  document.addEventListener('shopify:section:load', init);
})();
